import {useEffect, useState} from "react";

export default function CountDownTimer(
    {
        firstTimeInSeconds,
        endTimeMessage = "ارسال مجدد",
        endTimeClickedEvent
    }) {

    const [time, setTime] = useState(firstTimeInSeconds);

    useEffect(() => {
        if (typeof time !== 'undefined' && time !== 0) {
            let timeout = setTimeout(() => {
                setTime(time - 1)
            }, 1000);

            return (() => {
                clearInterval(timeout)
            })
        }
    }, [time])

    function prepareTimeFormat() {
        return `${('0' + Math.floor(time / 60)).toString().slice(-2)}:${('0' + time % 60).toString().slice(-2)}`
    }

    return (
        <div>
            {
                time !== 0 ?
                    prepareTimeFormat() :
                    <span>{endTimeMessage}</span>
            }
        </div>
    )
}
